/* eslint-disable security/detect-object-injection */
import { ICoreContext } from '@msdyn365-commerce/core';
import React from 'react';
import { toast } from 'sonner';
import { ILxsBillingDocument } from '../actions/get-billing-documents.action';
import GetDocumentDownload, { GetDocumentDownloadInput } from '../actions/get-document-download.action';
import { IOrderDetailDocument } from '../actions/get-order-details.action';
import { ILxsBillingDocumentsResources } from '../modules/lxs-billing-documents/lxs-billing-documents.props.autogenerated';
import { IOrderDetailsResources } from '../modules/order-details';

export default function documentDownloadItem({
    context,
    resources,
    documentItem,
    index
}: {
    context: ICoreContext;
    documentItem: IOrderDetailDocument | ILxsBillingDocument;
    resources: IOrderDetailsResources | ILxsBillingDocumentsResources;
    index: number;
}) {
    const documentDownloadRefs = React.useRef<HTMLAnchorElement[]>([]);
    const documentDownloadAlreadyDownloaded: number[] = [];

    const getDocumentDownload = async (documentId: string, index: number) => {
        try {
            const link = documentDownloadRefs.current[index];

            // Download and initiate click()/download only once
            if (!documentDownloadAlreadyDownloaded.includes(index)) {
                const actionInput = new GetDocumentDownloadInput(documentId);
                const documentDownload = await GetDocumentDownload(actionInput, context.actionContext);
                const documentContent = `data:application/pdf;base64,${documentDownload.Content}`;
                // Only prepare link if content is available
                if (documentDownload.Content.length === 0) {
                    toast.error(
                        <div className='toast' role='alert'>
                            <div className='toast-header'>
                                <h4>{resources.globalDownloadErrorHeading}</h4>
                                <button className='toast-close' onClick={() => toast.dismiss()}></button>
                            </div>
                            <div className='toast-body'>
                                <span>{resources.globalDownloadErrorNoContentDescription}</span>
                            </div>
                        </div>
                    );
                } else {
                    link.href = documentContent;
                    link.download = documentDownload.FileName;
                    documentDownloadAlreadyDownloaded.push(index);
                    link.click();
                }
            }
        } catch (error) {
            toast.error(
                <div className='toast' role='alert'>
                    <div className='toast-header'>
                        <h4>{resources.globalErrorHeading}</h4>
                        <button className='toast-close' onClick={() => toast.dismiss()}></button>
                    </div>
                    <div className='toast-body'>
                        <span>{resources.globalErrorServiceNotAvailable}</span>
                    </div>
                </div>
            );
            console.error('Error document download', error);
            return error;
        }

        return null;
    };

    return (
        <a
            ref={ref => {
                if (!documentDownloadRefs.current[Number(index)] && ref) {
                    documentDownloadRefs.current[Number(index)] = ref;
                }
            }}
            className='lxs-download-link'
            onClick={() => {
                const documentId =
                    documentItem && 'Document' in documentItem && documentItem.Document?.DocumentId
                        ? documentItem.Document.DocumentId
                        : documentItem.DocumentId;

                void getDocumentDownload(documentId, index);
            }}
        >
            <span>{'Name' in documentItem ? documentItem.Name : documentItem.DocumentId}</span>
        </a>
    );
}
